<bl-modal-content #content
  [title]="'一斉送信の内容をご確認ください'"
  [footerButtonType]="footerButtonType"
  [okButtonSetting]="okButtonSetting"
  [disableOkButton]="_snsSendMessageInfo.snsLinkageId === ''"
>
<div body>
  <table class="table table-bordered panel-insurance-top">
    <tr>
      <th class="dm-col-lg-2 va-m">LINE公式アカウント</th>
      <td class="va-m" colspan="3">
        <div class="col-sm-6 u-pd0l">
          <!-- 複数のときはセレクトボックス -->
          <bl-select
            *ngIf="hasMultipleLineAccount"
            [(value)]="_snsSendMessageInfo.snsLinkageId"
            [items]="lineOfficialAccountList"
            (changeEvent)="onChangeLineOfficialAccount($event)"
          ></bl-select>
          <!-- 単一のときはテキスト -->
          <div *ngIf="!hasMultipleLineAccount">{{_snsSendMessageInfo.snsShopAccountName}}</div>
        </div>
        <div class="lineAccount-note col-sm-6 d-flex align-items-center"
          *ngIf="_snsSendMessageInfo.snsLinkageId === ''">LINE公式アカウントを選択してください。</div>
      </td>
    </tr>
    <tr>
      <th class="dm-col-lg-2 va-m">送信する友だちの条件</th>
      <td class="va-m" colspan="3">
        <div class="detail-row">
          <div class="detail-item">
            <app-sns-send-message-condition-panel blFocusControl blCustomFocus
              [detailToggleBtnText]="'詳細条件'"
              (clearEvent)="onSearchConditonClear($event)"
            >
              <div class="basic-condition" basic-condition>
                <div class="basic-condition__row">
                  <bl-checkbox blCustomFocus
                    #firstFocusControl
                    [inline]="true"
                    [label]="'顧客未登録の友だちのみ'"
                    [value]="_snsExtractCondition.unregisteredFriendsFlg"
                    [checked]="_snsExtractCondition.unregisteredFriendsFlg"
                    (click)="onClickUnregisteredFriendsFlg($event)"
                    (changeEvent)="onChangeUnregisteredFriendsFlg()"
                  ></bl-checkbox>
                </div>
              </div>
              <div class="detail-condition" detail-condition>
                <div class="detail-row">
                  <div class="detail-item">
                    <label>ラベル</label>
                    <div class="u-flex align-items-center form-group">
                      <div class="search-condition-row__item">
                        <div class="w-350px">
                          <share-label-select-input
                            [labelUseCategory]="labelUseCategory"
                            [selectedCodeList]="_snsExtractCondition.labelCodeList"
                            [editable]="false"
                            [option]="{ previewNum: 5, dropup: false, parentAutoCheck: true }"
                            (changeListEvent)="onChangeLabel($event)"
                          ></share-label-select-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *shareServiceIf="ContractConst.SERVICEID_OPT_CMN_COUPON_MANAGE">
                  <div class="detail-row">
                    <div class="detail-item">
                      <div class="u-flex align-items-center form-group">
                        <div class="search-condition-row__item">
                          <bl-checkbox
                          [value]="_snsExtractCondition.searchNotTicketFlg"
                          [label]="'利用可能なクーポンを所持していない友だち'"
                          [checked]="_snsExtractCondition.searchNotTicketFlg"
                          (changeEvent)="onChangeSelectedSearchNotTicketFlg()"
                          ></bl-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detail-row" *ngIf="!_snsExtractCondition.searchNotTicketFlg">
                    <div class="detail-item">
                      <ng-container>
                        <div class="search-condition-row condition-input">
                          <label>下記のクーポンを所持している</label>
                          <ng-container *ngFor="let idx of _snsExtractCondition.ticketSettingList; index as i">
                            <div class="u-flex align-items-center form-group">
                              <div class="search-condition-row__item condition-input">
                                <div class="search-condition-input-ticket">
                                  <bl-guide-label
                                    #ticketGuideLabel
                                    [value]="idx?.ticketCode"
                                    [labelText]="idx?.ticketName"
                                    [hideDelete]="true"
                                    (clickGuideEvent)="onShowTicketGuideForSnsExtractCondition($event, i)"
                                  ></bl-guide-label>
                                </div>
                              </div>
                              <div class="contact-form__button">
                                <button class="btn btn-success btn-delete"
                                  (click)="onClickDeleteForSnsExtractCondition(i)">
                                  <span class="glyphicon glyphicon-minus"></span>
                                </button>
                              </div>
                            </div>
                          </ng-container>
                          <div class="item-add-button" *ngIf="_snsExtractCondition.ticketSettingList.length < 3">
                            <button class="btn btn-success"
                              (click)="onClickEditForSnsExtractCondition()">
                              <span class="glyphicon glyphicon-plus"></span>追加する
                            </button>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="detail-row" *ngIf="!_snsExtractCondition.searchNotTicketFlg">
                    <div class="detail-item__top">
                      <label>下記の期間内に使えるクーポンを所持している</label>
                      <div class="u-flex align-items-center form-group">
                        <div class="search-condition-row__item">
                          <div class="w-300px">
                            <bl-date
                              class="date-input"
                              [value]="_snsExtractCondition.applyStartDate"
                              (changeEvent)="onChangeApplyStartDate($event)"
                            ></bl-date>
                          </div>
                        </div>
                        <div class="wave-dash">〜</div>
                        <div class="search-condition-row__item">
                          <div class="w-300px">
                            <bl-date
                              class="date-input"
                              [value]="_snsExtractCondition.applyEndDate"
                              (changeEvent)="onChangeApplyEndDate($event)"
                            ></bl-date>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detail-row" *ngIf="!_snsExtractCondition.searchNotTicketFlg">
                    <div class="detail-item">
                      <label>下記の日にち以降に発行したクーポンを所持している</label>
                      <div class="u-flex align-items-center form-group">
                        <div class="search-condition-row__item">
                          <div class="w-300px">
                            <bl-date
                              class="date-input"
                              [value]="_snsExtractCondition.ticketIssueDate"
                              (changeEvent)="onChangeTicketIssueDate($event)"
                            ></bl-date>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detail-row" *ngIf="!_snsExtractCondition.searchNotTicketFlg">
                    <div class="detail-item">
                      <label>下記の期間内に期限が切れるクーポンを所持している</label>
                      <div class="u-flex align-items-center form-group">
                        <div class="search-condition-row__item">
                          <div class="w-300px">
                            <bl-date
                              class="date-input"
                              [value]="_snsExtractCondition.applyEndDateStart"
                              (changeEvent)="onChangeApplyEndDateStart($event)"
                            ></bl-date>
                          </div>
                        </div>
                        <div class="wave-dash">〜</div>
                        <div class="search-condition-row__item">
                          <div class="w-300px">
                            <bl-date
                              class="date-input"
                              [value]="_snsExtractCondition.applyEndDateEnd"
                              (changeEvent)="onChangeApplyEndDateEnd($event)"
                            ></bl-date>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </app-sns-send-message-condition-panel>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <label class="u-mg4b">友だち登録日</label>
            <div class="u-flex align-items-center form-group">
              <div >
                <bl-date
                  class="date-input"
                  [value]="_snsExtractCondition.snsFriendRegistDateFrom"
                  (changeEvent)="onChangeSnsFriendRegistDateFrom($event)"
                ></bl-date>
              </div>
              <div class="wave-dash">〜</div>
              <div >
                <bl-date
                  class="date-input"
                  [value]="_snsExtractCondition.snsFriendRegistDateTo"
                  (changeEvent)="onChangeSnsFriendRegistDateTo($event)"
                ></bl-date>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <label class="u-mg4b">最終メッセージ受信日</label>
            <div class="u-flex align-items-center form-group">
              <div >
                <bl-date
                  class="date-input"
                  [value]="_snsExtractCondition.snsLastMessageReceiveDateTimeFrom"
                  (changeEvent)="onChangeSnsLastMessageReceiveDateTimeFrom($event)"
                ></bl-date>
              </div>
              <div class="wave-dash">〜</div>
              <div >
                <bl-date
                  class="date-input"
                  [value]="_snsExtractCondition.snsLastMessageReceiveDateTimeTo"
                  (changeEvent)="onChangeSnsLastMessageReceiveDateTimeTo($event)"
                ></bl-date>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <th class="dm-col-lg-2 va-m">案内文の選択</th>
      <td class="col-lg-10" colspan="3">
        <div class="col-sm-7 u-pd0l">
          <bl-select #dmInvitationInitSelect
            [(value)]="_snsSendMessageInfo.dmContentNumber"
            [items]="contentInfoListArray"
            [disabled]="approachSelectDisabledFlg"
            (changeEvent)="onChangeInfoItem($event)"
          ></bl-select>
        </div>
        <button #dmInvitationInitEdit
          type="button"
          class="btn btn-default u-mg10l"
          (click)="addApproach($event)">案内文の作成</button>
      </td>
    </tr>
    <tr>
      <th class="dm-col-lg-2 va-m">一斉送信名称</th>
      <td class="va-m" colspan="3">
        <bl-text-input
          [(value)]="_snsSendMessageInfo.snsSendTitle"
          [maxlength]="60"
        ></bl-text-input>
      </td>
    </tr>
  </table>

  <app-sns-send-message-content
    #snsSendMessageContent
    [(entity)]="_snsSendMessageInfo && _snsSendMessageInfo.dmContentInfo && _snsSendMessageInfo.dmContentInfo"
    [(isSettingLineRichTemplate)]="_isSettingLineRichTemplate"
    [(isAvailableWebReserveService)]="isAvailableWebReserveService"
    [blFormGroup]="blFormGroup"
    (updateDmSnsMsgSettingEvent)="onUpdateDmSnsMsgSetting($event)"
  ></app-sns-send-message-content>

  <div>
    <table class="table table-bordered panel-insurance">
      <tr *shareServiceIf="ContractConst.SERVICEID_OPT_CMN_COUPON_MANAGE">
        <th class="dm-col-lg-2 va-m">発行するクーポンを選択</th>
        <td class="va-m" colspan="3">
          <div  *ngFor="let item of ticketSettingList; index as i" class="inner-item">
            <div class="contact-form">
              <div class="contact-form__name">
                <bl-guide-label #ticketGuideLabel
                  [value]="item?.ticketId"
                  [labelText]="item?.ticketName"
                  [hideDelete]="true"
                  (clickGuideEvent)="onShowTicketGuide($event, i)"
                ></bl-guide-label>
              </div>
              <div class="contact-form__button">
                <button class="btn btn-success btn-delete"
                  (click)="onClickDelete(i)">
                  <span class="glyphicon glyphicon-minus"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="item-add-button" *ngIf="ticketSettingList.length < 3">
            <button class="btn btn-success"
              (click)="onClickEdit()">
              <span class="glyphicon glyphicon-plus"></span>追加する
            </button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/sns-send-message-modal.component.html